module.exports = __webpack_public_path__ + "img/16_92.0cf104e6.png";